import { RouterReducerState } from '@ngrx/router-store';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectRouterState =
  createFeatureSelector<RouterReducerState>('router');

export const selectRouterChildren = createSelector(
  selectRouterState,
  (router) => router.state.root.firstChild.firstChild.children
);

export const selectRightOutlet = createSelector(
  selectRouterChildren,
  (children) => children.find((outlet) => outlet.outlet === 'right')
);

export const selectRightOutletParams = createSelector(
  selectRightOutlet,
  (child) => child.params
);

export const selectRightOutletParamId = createSelector(
  selectRightOutlet,
  (child) => child.params.id
);

export const selectRouterPrimaryOutlet = createSelector(
  selectRightOutlet,
  (child) => child.data.primaryOutlet
);

export const selectQueryParams = createSelector(
  selectRouterState,
  (router) => router.state.root.queryParams
);

export const selectCommercialQueryParam = createSelector(
  selectQueryParams,
  (queryParams) => queryParams.commercial === 'true' // converts to boolean, since queryParams are received as strings
);
